import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";
import TopBar from "./TopBar";
import { Outlet } from "react-router-dom";

const useStyles = makeStyles()(theme => ({
    root: {
        // backgroundColor: theme.palette.background.default,
        background: "linear-gradient(to bottom, #003B30 0%, #0C7B66 100%)",
        display: "flex",
        height: "100%",
        overflow: "hidden",
        width: "100%",
    },
    wrapper: {
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
        paddingTop: 64,
    },
    contentContainer: {
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
    },
    content: {
        flex: "1 1 auto",
        height: "100%",
        overflow: "auto",
    },
}));

const MainLayout = ({ children }) => {
    const { classes } = useStyles();

    return (
        <div className={classes.root}>
            <TopBar />
            <div className={classes.wrapper}>
                <div className={classes.contentContainer}>
                    <div className={classes.content}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

MainLayout.propTypes = {
    children: PropTypes.node,
};

export default MainLayout;
